import FetchUtils, { parseJSON } from './fetch_utils';
import { message } from 'antd';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { INTEGRATOR_CRUD_ACTION_CREATORS } from '../actions/integrator_actions';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export const integratorNamesRestCrudThunksForSupplier = new RestCrudThunks(
	'integrator_names/distinct',
	'integrator_name',
	'integratorName',
	'integratorNames',
	INTEGRATOR_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/purchase_orders/'
);

export const sendToIntegration = (id) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_orders/${id}/send_to_integration`;

	const data = {};
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
